module.exports = __webpack_public_path__ + "static/media/260.d57ef89f.svg";